import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { I18NextNS } from 'src/models/Language.model';

const useGetGalenErrorMsg = () => {
  const { t } = useTranslation(I18NextNS.COMMON);

  const getErrorMessage = useCallback(
    (key: string) => {
      return t(`message.error.${key}`, { defaultValue: 'Unknown error' });
    },
    [t],
  );

  return { getErrorMessage };
};

export default useGetGalenErrorMsg;
